import { toast } from 'react-toastify';
import axios from 'axios';

import {
  DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_BEGIN,
  DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_SUCCESS,
  DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_FAILURE,
  DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function pushToGitHub(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export/github/push/${args.id}`,
        {},
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_SUCCESS,
            data: res,
          });
          return resolve(res);
        },
        (err) => {
          let finalError = '';
          const { response } = err;
          if (response && response.data) {
            const { message, details, error } = response.data;
            if (message !== undefined) {
              finalError = message;
            } else {
              console.log('This is the details of the error: ', details);
              finalError = error;
            }
            console.log('This is the response in the error filed: ', response);
            console.log('This is the response.data in the error filed', response.data);
            toast.error(`Failed: ${finalError}`, {});
            dispatch({
              type: DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_FAILURE,
              data: { error: finalError },
            });
            return reject(finalError);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_FAILURE,
              data: { error: err },
            });
            return reject(err);
          }
        },
      );
    });

    return promise;
  };
}

export function dismissPushToGitHubError() {
  return {
    type: DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_BEGIN:
      return {
        ...state,
        pushToGitHubPending: true,
        pushToGitHubError: null,
      };

    case DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_SUCCESS:
      return {
        ...state,
        pushToGitHubPending: false,
        pushToGitHubError: null,
      };

    case DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_FAILURE:
      return {
        ...state,
        pushToGitHubPending: false,
        pushToGitHubError: action.data.error,
      };

    case DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_DISMISS_ERROR:
      return {
        ...state,
        pushToGitHubError: null,
      };

    default:
      return state;
  }
}
